<template>
  <dl
    v-if="icon"
    class="icon-details-version-info display-inline-flex flex-items-center"
    style="--margin-bottom: 0; --padding-left: 0; gap: var(--spacing-md); --tag-background: var(--fa-lt-gravy)"
  >
    <dt
      class="muted sr-only"
      style="--margin-bottom: 0; font-weight: var(--font-weight-normal)"
    >
      {{ isCustomIcon ? 'Uploaded:' : 'Released:' }}
    </dt>
    <dd style="--margin-bottom: 0">
      <span class="tag rounded text-select-all">{{ releasedVersion }}</span>
    </dd>

    <template v-if="releasedVersion !== updatedVersion">
      <dt
        class="muted margin-left-sm sr-only"
        style="--margin-bottom: 0; font-weight: var(--font-weight-normal)"
      >
        Updated:
      </dt>
      <dd style="--margin-bottom: 0">
        <span class="tag rounded text-select-all">{{ updatedVersion }}</span>
      </dd>
    </template>
  </dl>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'IconVersionInfo',

    props: {
      icon: {
        type: Object
      },
      isCustomIcon: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      releasedVersion() {
        if (this.isCustomIcon) {
          return moment.utc(this.icon.insertedAt).fromNow()
        } else {
          const added = this.icon.changes[0]
          return added?.includes('beta') ? added.slice(0, -6) : added
        }
      },

      updatedVersion() {
        if (this.isCustomIcon) {
          return moment.utc(this.icon.updatedAt).fromNow()
        } else {
          const updated = this.icon.changes[this.icon.changes.length - 1]
          return updated?.includes('beta') ? updated.slice(0, -6) : updated
        }
      }
    }
  }
</script>
